import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
    PdvEvidencijaZbirna39Dto,
  PdvEvidencijeClient,
  
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PdvEvidencijaZbirna39Resolver
  extends BaseService
  implements Resolve<PdvEvidencijaZbirna39Dto> {
  constructor(private _client: PdvEvidencijeClient) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<PdvEvidencijaZbirna39Dto>
    | Promise<PdvEvidencijaZbirna39Dto>
    | PdvEvidencijaZbirna39Dto
    | null {
    const id = Number.parseInt(route.paramMap.get('id')!);
    return this._client.getPdvEvidencijaZbirna39(id).pipe(
      map((x) => x.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
